import { Box, Button, CircularProgress, Grid, InputLabel, TextField, Tooltip, useTheme } from '@material-ui/core';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { Autocomplete } from '@material-ui/lab';
import {
  CheckBox,
  Checkbox,
  CheckboxCheckIconTwoTone,
  CloseIcon,
  // DatePicker,
  EditIconTwoTone,
  InformationIcon,
  LoadingSpinnerIconTwoTone,
  Select,
  SelectArrowDownIcon,
  SingleFieldContactInput,
  TextInput,
  Typography,
  useConfirmationModal,
} from '@room-match/shared-ui-components';
import { LocationModal } from 'components/LocationModal';
import { CustomDialog } from 'components/RegistrationForm/AdultForm/PersonalInformation/PersonalInformation.styles';
import RepresentationChip from 'components/RegistrationForm/RepresentationUnionChip/RepresentationChip';
import UnionChip from 'components/RegistrationForm/RepresentationUnionChip/UnionChip';
import {
  CustomIconButton,
  LocationActions,
  LocationContainer,
} from 'components/Settings/GeneralInformation/GeneralInformation.styles';
import EthnicAppearances from 'data/EthnicAppearances.json';
import Gender from 'data/Gender.json';
import region from 'data/Region.json';
import unionList from 'data/Unions.json';
import { FormikProps } from 'formik';
import moment from 'moment-timezone';
import AdultSlider from 'pages/MyInfo/GeneralAppearance/AdultSlider';
import MinorSlider from 'pages/MyInfo/GeneralAppearance/MinorSlider';
import React, { useEffect, useMemo, useState } from 'react';
import { BsAsterisk } from 'react-icons/bs';
import { COLORS } from 'shared/constants/COLORS';
const { PASS_INDICATOR, ERROR_INDICATOR, DARK_BORDER, PRIMARY_BUTTON_BACKGROUND } = COLORS;
import { RepresentationType } from 'shared/enums/RepresentationType';
import { useEmailValidation } from 'shared/hooks/useEmailValidation';
import { IUnion } from 'shared/interfaces/IAccount';
import { IAddress } from 'shared/interfaces/IAddress';
import { IGeneralSection } from 'shared/interfaces/IGeneral';
import { INewProfileMatchReponsePayload } from 'shared/interfaces/IProfile';
import { ICreateTalentPayload } from 'shared/interfaces/ITalent';
import { IUser } from 'shared/interfaces/IUser';
import { agencyService } from 'shared/services/agencyService';
import { countryStateApiService } from 'shared/services/countryStateApiService';
import { getCountry, getCountryCode } from 'shared/utils/countryStateMapper';
import { ls } from 'shared/utils/ls';
import { getErrorMessage } from 'shared/utils/room-shared';
import { useDebounce } from 'use-debounce';
import { useStyles } from './AddNewMember.styles';
import DatePicker from './DatePicker/DatePicker';
import NumberConsent from 'shared/components/NumberConsent/NumberConsent';
import { emailValidation } from 'shared/utils/common';
interface Props {
  form: FormikProps<ICreateTalentPayload>;
  representatives: any[];
  setRepresentatives(representatives: any[]): void;
  isMemberMinor: (type: boolean) => void;
  isForGuardian: (is: boolean) => void;
  disableProfile: boolean;
  user: IUser;
  setFirstName(firstName: string): void;
  setLastName(lastName: string): void;
  profileMatch?: INewProfileMatchReponsePayload;
  val: number[] | null;
  setVal: (number: number[]) => void;
  selectedLocation: IAddress | null;
  setSelectedLocation: React.Dispatch<React.SetStateAction<IAddress | null>>;
  generalInfo: IGeneralSection;
  setgeneralInfo: React.Dispatch<React.SetStateAction<IGeneralSection>>;
  guardianCountryCode: string;
}
const { getAgencies, getCompany } = agencyService();
const { getCountries } = countryStateApiService();

const months = [
  {
    key: 'Jan',
    value: 1,
    disabled: false,
  },
  {
    key: 'Feb',
    value: 2,
    disabled: false,
  },
  {
    key: 'Mar',
    value: 3,
    disabled: false,
  },
  {
    key: 'Apr',
    value: 4,
    disabled: false,
  },
  {
    key: 'May',
    value: 5,
    disabled: false,
  },
  {
    key: 'Jun',
    value: 6,
    disabled: false,
  },
  {
    key: 'Jul',
    value: 7,
    disabled: false,
  },
  {
    key: 'Aug',
    value: 8,
    disabled: false,
  },
  {
    key: 'Sep',
    value: 9,
    disabled: false,
  },
  {
    key: 'Oct',
    value: 10,
    disabled: false,
  },
  {
    key: 'Nov',
    value: 11,
    disabled: false,
  },
  {
    key: 'Dec',
    value: 12,
    disabled: false,
  },
];

const AddNewMember: React.FC<Props> = ({
  form,
  representatives,
  setRepresentatives,
  isMemberMinor,
  isForGuardian,
  disableProfile,
  user,
  setFirstName,
  setLastName,
  profileMatch,
  val,
  setVal,
  selectedLocation,
  setSelectedLocation,
  generalInfo,
  setgeneralInfo,
  guardianCountryCode,
}) => {
  const theme = useTheme();
  const { isEmailValidationLoading, isValidEmail, handleEmailChange, emailValue } = useEmailValidation();
  const [openLocationModal, setopenLocationModal] = useState(false);
  const classes = useStyles();
  const { getLS } = ls();
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const [workPermit, setworkPermit] = useState<boolean>(form.values.with_minor_work_permit || false);
  const [type, setType] = useState<'adult' | 'minor'>(form.values.adult_minor);
  const [query, setQuery] = useState<string>('');
  const [queryValue] = useDebounce(query, 100);
  const [representativesLabel, setRepresentativesLabel] = useState<string[]>([]);
  const [agencyRegion, setagencyRegion] = useState('Australia');
  const [openAgeRangeModal, setopenAgeRangeModal] = useState(false);
  const [country, setCountry] = useState<string>('');

  const getDaysinMonth = (month: number | string, year: number | string) => {
    return new Date(Number(year), Number(month), 0).getDate();
  };

  const setDaysArr = (days: number, maxDays?: number) =>
    Array.from({ length: days }, (_, i) => {
      return {
        key: (i + 1).toString(),
        value: i + 1,
        disabled: maxDays ? i + 1 > maxDays : false,
      };
    });

  const [dobYear, setDobYear] = useState<number | string>(0);
  const [dobMonth, setDobMonth] = useState<number | string>(0);
  const [dobDay, setDobDay] = useState<number | string>(0);

  const [calendarMonths, setCalendarMonths] = useState(months.slice(0, new Date().getMonth() + 1));
  const [calendarDays, setCalendarDays] = useState(
    Array.from(
      {
        length: new Date().getDate(),
      },
      (_, i) => {
        return {
          key: (i + 1).toString(),
          value: i + 1,
          disabled: false,
        };
      },
    ),
  );
  const [calendarYears, setCalendarYears] = useState(
    Array.from({ length: 19 }, (_, i) => {
      const year = new Date().getFullYear() - 19;
      return {
        key: (year + i + 1).toString(),
        value: year + i + 1,
      };
    }),
  );

  const agency = JSON.parse(getLS('agency') || '{}');
  const { data: countriesData } = getCountries();

  const [slug2, setslug2] = useState('');

  const { data: companyData, isLoading: isLoadingCompany } = getCompany(agency?.slug || '');
  const { data: companyData2 } = getCompany(slug2);

  const momentNow = moment(new Date());
  // const birthString = moment(form.values.birth_date).format('YYYY-MM-DD');
  const birthMoment = moment(form.values.birth_date);

  const duration = momentNow.diff(birthMoment, 'year');

  const curryear = new Date().getFullYear();
  const currmonth = new Date().getMonth() + 1;
  const currday = new Date().getDate();

  useEffect(() => {
    const days = getDaysinMonth(dobMonth, dobYear);
    let mm = dobMonth;
    let dd = dobDay;
    const baseYear = type === 'adult' ? curryear - 18 : curryear;
    if (baseYear === dobYear) {
      const disabledMonths = months.map((mo, i) => (i >= currmonth ? { ...mo, disabled: true } : mo));
      setCalendarMonths(disabledMonths);
      setCalendarDays(setDaysArr(days, currday));
      mm = currmonth;
      if ((dobMonth as number) >= currmonth) {
        setDobMonth(currmonth);
        if ((dobDay as number) > currday) {
          setDobDay(currday);
          dd = currday;
        }
        mm = currmonth;
      } else {
        setCalendarDays(setDaysArr(days));
      }
    } else {
      setCalendarMonths(months);
      setCalendarDays(setDaysArr(days));
      if ((dobDay as number) > days && currday > days) {
        setDobDay(days);
        dd = days;
      }
    }
    //Disable the month/s if it already exceeds minor age
    if (type === 'minor' && dobYear === curryear - 18) {
      setCalendarMonths(
        months.map((month) => ({
          ...month,
          disabled: month.value < currmonth,
        })),
      );
    }
    //Disable the day/s if it already exceeds minor age
    if (type === 'minor' && dobYear === curryear - 18 && dobMonth === currmonth) {
      setCalendarDays(
        setDaysArr(days).map((day) => ({
          ...day,
          disabled: day.value < currday + 1,
        })),
      );
    }
    const dateOfBirth = `${dobYear}-${('0' + mm).slice(-2)}-${('0' + dd).slice(-2)}`;
    if (type === 'minor' && dobYear && dobMonth && dobDay && moment().diff(moment(dateOfBirth), 'years') >= 18) {
      //Set birthdate to oldest age possible within a minor bracket
      setDobYear(curryear - 18);
      setDobMonth(currmonth);
      setDobDay(currday + 1);
      const duration = 0;
      setVal([duration, duration + 2]);
    } else if (type === 'minor' && dobYear && dobMonth && dobDay) {
      const duration = moment().diff(moment(dateOfBirth), 'year');
      if (duration >= 2) {
        setVal([duration - 1, duration + 1]);
      }
    }
    form.setFieldValue('birth_date', dateOfBirth);
  }, [dobMonth, dobDay, dobYear]);

  useEffect(() => {
    const days = getDaysinMonth(currmonth, curryear);
    setDobMonth('');
    setDobDay('');
    setCalendarDays(setDaysArr(days, currday));
    const disabledMonths = months.map((mo, i) => (i >= currmonth ? { ...mo, disabled: true } : mo));
    setCalendarMonths(disabledMonths);

    const setYearRange = (length: number, range: number) =>
      Array.from({ length: length }, (_, i) => {
        const year = new Date().getFullYear() - range;
        return {
          key: (year + i + 1).toString(),
          value: year + i + 1,
        };
      });
    if (type === 'minor') {
      setCalendarYears(setYearRange(19, 19));
      setDobYear('');
    } else {
      setCalendarYears(setYearRange(82, 100));
      setDobYear('');
    }
  }, [type]);

  useEffect(() => {
    if (profileMatch?.data[0]?.slug) {
      setslug2(profileMatch?.data[0]?.slug);
    } else {
      setslug2('');
    }
  }, [profileMatch?.data]);

  useEffect(() => {
    let joinedRep: any[] = [];
    if (companyData2?.data) {
      const companyDataWithIsCompany = {
        ...companyData2?.data,
        attributes: {
          ...companyData2?.data?.attributes,
          isCompany: true,
        },
      };
      // captureMessage({
      //   message: '123123',
      //   data: { companyDataWithIsCompany },
      // });
      const newRep = [...joinedRep, companyDataWithIsCompany as any];
      joinedRep = newRep;
    }

    if (companyData?.data) {
      const companyDataWithIsCompany = {
        ...companyData?.data,
        attributes: {
          ...companyData?.data?.attributes,
          isCompany: true,
        },
      };
      const newRep = [...joinedRep, companyDataWithIsCompany as any];
      joinedRep = newRep;
    }

    setRepresentatives(joinedRep.filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i));
  }, [companyData2?.data, companyData?.data]);

  const { data: agencies, isLoading: isAgencyLoading } = getAgencies({
    country: agencyRegion,
    search: queryValue,
  });

  const getData = useMemo(() => {
    if (isAgencyLoading) {
      return;
    } else {
      return agencies
        ? agencies.pages.filter((v, index) => index === 0).map((i) => i.data.agencies_connection.nodes)[0]
        : undefined;
    }
  }, [agencies, isAgencyLoading]);

  const [unionToAdd, setUnionToAdd] = useState<IUnion>({
    name: '',
    id_number: '',
  });
  const countries = region.map((region) => ({ key: region.value, value: region.value }));

  const addUnion = () => {
    const getUnionValues = form.values.unions || [];
    form.setFieldValue('unions', [
      ...getUnionValues,
      {
        name: unionToAdd.name,
        id_number: unionToAdd.id_number,
      },
    ]);

    setUnionToAdd({ name: '', id_number: '' });
  };

  const removeUnion = (id: string) => {
    if (Boolean(form.values.unions) && form.values.unions?.length === 1) {
      form.setFieldValue(
        'unions',
        form.values.unions.filter((v) => v.id_number !== id),
      );
    }
  };

  useEffect(() => {
    if (isValidEmail) {
      if (form.errors.email === 'Invalid email address') form.setFieldError('email', '');
    } else {
      form.setFieldError('email', 'Invalid email address');
    }
  }, [isValidEmail, form.errors.email]);

  const handleRemoveRepresentative = (v: string) => {
    const filteredRepresentatives = representatives.filter((k) => k.id != v);
    setRepresentatives(filteredRepresentatives);
    const filteredRepresentativesLabel = representativesLabel.filter((k) => k != v);
    setRepresentativesLabel(filteredRepresentativesLabel);
  };

  // Detect if country is AU
  const selectedCountry = guardianCountryCode === 'au';

  useEffect(() => {
    const { first_name, last_name, middle_name, contact_no, country_code } = user.attributes;
    console.log(' first inside useeffect', { country_code });

    isMemberMinor(type === 'minor');
    isForGuardian(isChecked);
    form.setValues({
      ...form.values,
      contact_no,
      country_code,
    });
    if (isChecked) {
      form.setValues({
        ...form.values,
        first_name,
        last_name,
        middle_name,
        stage_first_name: first_name,
        stage_last_name: last_name,
      });
    }
  }, [type, isChecked]);

  useEffect(() => {
    setLastName(form.values.stage_last_name || '');
    setFirstName(form.values.stage_first_name || '');
  }, [form.values.stage_first_name, form.values.stage_last_name]);
  const now = new Date();

  // console.log(`${now.getFullYear() - 18}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getDate()}`);

  // console.log(
  //   now.getFullYear() - 18,
  //   (now.getMonth() + 1).toString().padStart(2, '0'),
  //   now.getDate().toString().padStart(2, '0'),
  // );

  const handleOnDateChange = (value: any) => {
    // form.setFieldValue('birth_date', moment(value as Date).format('YYYY-MM-DD'))
    //format('YYYY-MM-DD') using native js date

    const date = new Date(value);
    const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date
      .getDate()
      .toString()
      .padStart(2, '0')}`;
    form.setFieldValue('birth_date', formattedDate);

    const momentNow = moment(new Date());
    const birthMoment = moment(date);
    const duration = momentNow.diff(birthMoment, 'year');
    if (duration >= 2) {
      if (type === 'minor') setVal([duration - 1, duration + 1]);
    } else {
      setVal([0, 2]);
    }
  };

  const renderAgeSlider = () => (
    <Grid item>
      <InputLabel style={{ justifyContent: 'unset', marginTop: 15 }}>
        Age Range
        <BsAsterisk className="required-asterisk" />
      </InputLabel>
      <LocationContainer
        $isEmpty={true}
        style={{ border: `solid 1px ${DARK_BORDER}`, cursor: 'pointer', marginBottom: 10 }}
        onClick={() => setopenAgeRangeModal(true)}
      >
        {val ? (
          <p style={{ fontSize: 14 }}>
            {val[0]} to {val[1]}
          </p>
        ) : (
          <p style={{ fontSize: 14 }}>No Age Range Added</p>
        )}
      </LocationContainer>
    </Grid>
  );

  const renderWorkingLocation = () => (
    <div style={{ gap: 5, display: 'flex', flexDirection: 'column', marginTop: 20 }}>
      <InputLabel id="primaryLocation" style={{ marginTop: representatives.length ? 0 : -20 }}>
        Working Location
      </InputLabel>
      {selectedLocation ? (
        <LocationContainer style={{ padding: '0 0 0 15px' }}>
          <p style={{ maxWidth: 245, fontSize: 14 }}>
            {selectedLocation.attributes?.city_suburb} /{' '}
            {getCountry(countriesData, selectedLocation.attributes?.country_code || '')} /{' '}
            {selectedLocation.attributes?.zip_code}
          </p>
          <LocationActions>
            <CustomIconButton style={{ height: 48, marginLeft: 10 }}>
              <EditIconTwoTone
                data-cy="edit-working-location"
                className="icon-primary"
                onClick={() => {
                  setopenLocationModal(true);
                }}
              />
            </CustomIconButton>
          </LocationActions>
        </LocationContainer>
      ) : (
        <LocationContainer data-cy="working-location" $isEmpty={true} onClick={() => setopenLocationModal(true)}>
          <p style={{ fontSize: 14 }}>No Location Added</p>
          <LocationActions></LocationActions>
        </LocationContainer>
      )}
    </div>
  );

  const handleAutocompleteChange = (field_key: string, val: string | null) => {
    setgeneralInfo((i) => ({ ...i, [field_key]: val }));
  };

  console.log(form.values.contact_no, 'contact_no');
  useEffect(() => {
    //check if form vountry code is touched
    if (form.touched.country_code) return;
    const code = (profileMatch?.data || []).length
      ? getCountryCode(countriesData, profileMatch?.data[0].agency_country || 'au').toLowerCase()
      : agency.country
        ? getCountryCode(countriesData, agency.country).toLowerCase()
        : form.values.country_code;
    console.log('setcode', code);
    if (code !== form.values.country_code) {
      form.setFieldValue('country_code', code);
    }
  }, [profileMatch, agency, countriesData, form]);

  useEffect(() => {
    setCountry(
      form.values.country_code === 'au'
        ? 'Australia'
        : form.values.country_code === 'us'
          ? 'United States'
          : form.values.country_code === 'nz'
            ? 'New Zealand'
            : '',
    );
  }, [form.values.country_code]);

  const dateInformation = [
    {
      id: 'month',
      value: dobMonth,
      data: calendarMonths,
      name: 'dobMonth',
      onChange: (e: React.ChangeEvent<{ name?: string; value: unknown }>) => setDobMonth(Number(e.target.value)),
      placeholder: 'Month',
    },
    {
      id: 'day',
      value: dobDay,
      data: calendarDays,
      name: 'dobDay',
      onChange: (e: React.ChangeEvent<{ name?: string; value: unknown }>) => setDobDay(Number(e.target.value)),
      placeholder: 'Day',
    },
    {
      id: 'year',
      value: dobYear,
      data: calendarYears,
      name: 'dobYear',
      onChange: (e: React.ChangeEvent<{ name?: string; value: unknown }>) => setDobYear(Number(e.target.value)),
      placeholder: 'Year',
    },
  ];

  // Format the date
  const formatDate = selectedCountry
    ? [dateInformation[1], dateInformation[0], dateInformation[2]]
    : [dateInformation[0], dateInformation[1], dateInformation[2]];

  return (
    <Box component="div" className={classes.root}>
      <Grid item className={classes.header}>
        <p style={{ fontSize: 24 }}>Add New Member</p>
        <Grid item className={classes.typeSelection}>
          <Box
            component="div"
            onClick={() => {
              setType('minor');
              form.setFieldValue('birth_date', '');
              form.setFieldValue('adult_minor', 'minor');
              setVal([0, 2]);
            }}
            className={`${classes.selection} ${type === 'minor' ? 'active' : ''}`}
          >
            <p style={{ fontSize: 16 }}>Minor Member</p>
            <Typography color="primary" fontSize={14}>
              Under 18 Years
            </Typography>
          </Box>
          <Box
            component="div"
            data-cy="adult-member"
            onClick={() => {
              setType('adult');
              form.setFieldValue('birth_date', '');
              form.setFieldValue('adult_minor', 'adult');
              setVal([15, 23]);
            }}
            className={`${classes.selection} ${type === 'adult' ? 'active' : ''}`}
          >
            <p style={{ fontSize: 16 }}>Adult Member</p>
            <Typography color="primary" fontSize={14}>
              18 Years+
            </Typography>
          </Box>
        </Grid>
      </Grid>
      <Grid item className={classes.form}>
        {type === 'minor' ? (
          <>
            <Grid item>
              <InputLabel style={{ justifyContent: 'unset', marginBottom: 10 }}>
                Date of Birth
                <BsAsterisk className="required-asterisk" />
              </InputLabel>
              <Grid container spacing={1}>
                {formatDate.map((date) => (
                  <Grid item xs={4} key={date.id}>
                    <Select
                      data-cy={
                        date.name === 'dobYear'
                          ? 'year-dropdown'
                          : date.name === 'dobMonth'
                            ? 'month-dropdown'
                            : date.name === 'dobDay'
                              ? 'day-dropdown'
                              : undefined
                      }
                      variant="outlined"
                      fullWidth
                      data={date.data}
                      value={date.value}
                      IconComponent={SelectArrowDownIcon}
                      name={date.name}
                      onChange={date.onChange}
                      placeHolder={date.placeholder}
                    />
                  </Grid>
                ))}
              </Grid>
              {duration >= 2 ? renderAgeSlider() : <React.Fragment />}
              <Grid item className={classes.checkboxContainer} style={{ marginTop: 20 }}>
                <Checkbox
                  data-cy="manage-by-minor-checkbox"
                  value={form.values.managed_by_minor}
                  onChange={form.handleChange}
                  label="This profile will be managed by the minor"
                  name="managed_by_minor"
                  labelPlacement="end"
                />
              </Grid>
            </Grid>
            {form.values.managed_by_minor ? (
              <Grid item>
                <Grid item style={{ marginBottom: 20 }}>
                  <InputLabel style={{ justifyContent: 'unset' }}>
                    Minor Cell Number
                    <BsAsterisk className="required-asterisk" />
                  </InputLabel>
                  <SingleFieldContactInput
                    style={{ width: '100%' }}
                    country={form.values.country_code}
                    name={'contact_no'}
                    inputValue={form.values.contact_no?.toString() || ''}
                    onChange={(value, data) => {
                      form.setTouched({ ...form.touched, country_code: true });
                      form.setValues({
                        ...form.values,
                        contact_no: value,
                        country_code: data.countryCode,
                        // country: getCountry(countriesData, data.countryCode.toUpperCase() || 'AU'),
                      });

                      console.log('change');
                    }}
                  />

                  <NumberConsent
                    aggreed={form.values.preferences?.notification?.sms || false}
                    setAgreed={(value: boolean) => form.setFieldValue('preferences.notification.sms', value)}
                  />
                </Grid>
                <Grid item>
                  <InputLabel style={{ justifyContent: 'unset' }}>Minor's email address for castings</InputLabel>
                  <TextInput
                    errorMessage={getErrorMessage(form.touched.email, form.errors.email)}
                    data-cy="minor-email"
                    name="email"
                    value={form.values.email}
                    placeholder="Enter email…"
                    onChange={(e) => {
                      if (form.errors.email && !form.touched.email) {
                        form.setFieldTouched('email');
                      }
                      form.handleChange(e);
                      handleEmailChange(e.target.value.trim());
                    }}
                    InputProps={{
                      endAdornment: (
                        <>
                          {emailValue && (
                            <>
                              {isEmailValidationLoading ? (
                                <LoadingSpinnerIconTwoTone style={{ fontSize: 40, position: 'absolute', right: 0 }} />
                              ) : (
                                <>
                                  <FiberManualRecordIcon
                                    data-cy="email-indicator-valid"
                                    style={{
                                      fontSize: 12,
                                      color: emailValidation(emailValue) ? PASS_INDICATOR : ERROR_INDICATOR,
                                    }}
                                  />
                                </>
                              )}
                            </>
                          )}
                        </>
                      ),
                    }}
                  />
                </Grid>
              </Grid>
            ) : (
              ''
            )}
            <Grid item>
              <InputLabel>Does the minor have a current work permit?</InputLabel>
              <Select
                data-cy="work-permit-dropdown"
                variant="outlined"
                fullWidth
                className={classes.select}
                data={[
                  { key: 'Yes', value: 'Yes' },
                  { key: 'No', value: 'No' },
                ]}
                value={workPermit ? 'Yes' : 'No'}
                // IconComponent={SelectArrowDownIcon}
                onChange={(e) => {
                  setworkPermit(e.target.value === 'Yes');
                  form.setFieldValue('with_minor_work_permit', e.target.value === 'Yes');
                }}
              />
            </Grid>
            {workPermit && (
              <Grid item>
                <InputLabel style={{ marginBottom: 10 }}>Work permit expiration date</InputLabel>
                <DatePicker
                  componentType="input"
                  onChooseDate={(value) => form.setFieldValue('work_permit_expired_at', value)}
                  value={form.values.work_permit_expired_at || undefined}
                  theme={theme.palette.type}
                />
              </Grid>
            )}
          </>
        ) : (
          <>
            {localStorage.hide_guardian ? (
              <React.Fragment />
            ) : (
              <Grid item className={classes.checkboxContainer} style={{ minWidth: 420 }}>
                <Checkbox
                  data-cy="guardian-profile"
                  disabled={disableProfile}
                  value={isChecked}
                  onChange={() => setIsChecked(!isChecked)}
                  label="This profile is for the guardian"
                  name="managed_by_minor"
                  labelPlacement="end"
                />
                {disableProfile && (
                  <Typography style={{ fontStyle: 'italic', fontSize: 12, margin: '-5px 0 0 25px', color: '#8A8C8F' }}>
                    (Guardian profile already created)
                  </Typography>
                )}
              </Grid>
            )}

            <Grid item>
              <InputLabel style={{ justifyContent: 'unset', marginBottom: 10 }}>
                Date of Birth
                <BsAsterisk className="required-asterisk" />
              </InputLabel>
              <Grid container spacing={1}>
                <Grid item xs={4}>
                  <Select
                    data-cy="month-dropdown"
                    variant="outlined"
                    fullWidth
                    data={calendarMonths}
                    value={dobMonth}
                    IconComponent={SelectArrowDownIcon}
                    name="dobMonth"
                    onChange={(e) => {
                      setDobMonth(Number(e.target.value));
                    }}
                    placeHolder="Month"
                  />
                </Grid>
                <Grid item xs={4}>
                  <Select
                    data-cy="day-dropdown"
                    variant="outlined"
                    fullWidth
                    data={calendarDays}
                    value={dobDay}
                    IconComponent={SelectArrowDownIcon}
                    name="dobDay"
                    onChange={(e) => {
                      setDobDay(Number(e.target.value));
                    }}
                    placeHolder="Day"
                  />
                </Grid>
                <Grid item xs={4}>
                  <Select
                    data-cy="year-dropdown"
                    variant="outlined"
                    fullWidth
                    data={calendarYears}
                    value={dobYear}
                    IconComponent={SelectArrowDownIcon}
                    name="dobYear"
                    onChange={(e) => {
                      setDobYear(Number(e.target.value));
                    }}
                    placeHolder="Year"
                  />
                </Grid>
              </Grid>
            </Grid>

            {renderAgeSlider()}

            {!isChecked && (
              <>
                <Grid item style={{ marginBottom: 10 }}>
                  <InputLabel style={{ justifyContent: 'unset' }}>
                    Cell Number
                    <BsAsterisk className="required-asterisk" />
                  </InputLabel>
                  <SingleFieldContactInput
                    style={{ width: '100%' }}
                    country={form.values.country_code}
                    name={'contact_no'}
                    inputValue={(form.values.other_phone_numbers || [])[0]?.number}
                    onChange={(value, data) => {
                      form.setTouched({ ...form.touched, country_code: true });
                      form.setValues({
                        ...form.values,
                        contact_no: value,
                        country_code: data.countryCode,
                        // country: getCountry(countriesData, data.countryCode.toUpperCase() || 'AU'),
                      });
                    }}
                  />
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <NumberConsent
                      aggreed={form.values.preferences?.notification?.sms || false}
                      setAgreed={(value: boolean) => form.setFieldValue('preferences.notification.sms', value)}
                    />
                    {/* <Tooltip
                      title={
                        <div style={{ textAlign: 'justify' }}>
                          <span style={{ fontSize: 11 }}>
                            Receive SMS notifications for audition reminders, casting calls, and other important
                            updates.
                          </span>
                          <br />
                            <span style={{ fontSize: 11 }}>
                              Our ZERO risk offer to encourage you to put your best foot forward to casting directors.
                            </span>
                        </div>
                      }
                    >
                      <span style={{ display: 'flex' }}>
                        <InformationIcon style={{ cursor: 'pointer', fontSize: '16px' }} />
                      </span>
                    </Tooltip> */}
                  </div>
                </Grid>
                <Grid item>
                  <InputLabel style={{ justifyContent: 'unset' }}>
                    Email address for castings
                    <BsAsterisk className="required-asterisk" />
                  </InputLabel>
                  <TextInput
                    data-cy="adult-email"
                    errorMessage={getErrorMessage(form.touched.email, form.errors.email)}
                    // label={'Email address for castings'}
                    name="email"
                    value={form.values.email}
                    placeholder="Enter email…"
                    onChange={(e) => {
                      form.setFieldTouched('email');
                      form.handleChange(e);
                      form.setFieldValue('email', e.target.value.trim());
                      handleEmailChange(e.target.value.trim());
                    }}
                    InputProps={{
                      endAdornment: (
                        <>
                          {emailValue && (
                            <>
                              {isEmailValidationLoading ? (
                                <LoadingSpinnerIconTwoTone style={{ fontSize: 40, position: 'absolute', right: 0 }} />
                              ) : (
                                <>
                                  {emailValidation(emailValue) ? (
                                    <FiberManualRecordIcon
                                      data-cy="email-indicator-valid"
                                      style={{ fontSize: 12, color: PASS_INDICATOR }}
                                    />
                                  ) : (
                                    <FiberManualRecordIcon
                                      data-cy="email-indicator-invalid"
                                      style={{ fontSize: 12, color: ERROR_INDICATOR }}
                                    />
                                  )}
                                </>
                              )}
                            </>
                          )}
                        </>
                      ),
                    }}
                  />
                </Grid>
              </>
            )}
          </>
        )}

        <Grid item style={{ marginBottom: 5 }}>
          <InputLabel style={{ justifyContent: 'unset' }}>
            Legal Name
            <BsAsterisk className="required-asterisk" />
          </InputLabel>
          <TextInput
            autoComplete="off"
            data-cy="legal-first-name"
            placeholder="First name…"
            name="first_name"
            value={form.values.first_name}
            onBlur={(e) => {
              form.handleBlur(e);
              form.setFieldValue('first_name', e.target.value.trim());
            }}
            onChange={(e) => {
              if (!form.touched.stage_first_name) form.setFieldValue('stage_first_name', e.target.value.trim());
              // setFirstName(e.target.value.trim());
              if (form.errors.first_name && !form.touched.first_name) {
                form.setFieldTouched('first_name');
                form.validateField('first_name');
              }

              form.handleChange(e);
            }}
            errorMessage={getErrorMessage(form.touched.first_name, form.errors.first_name)}
          />
          <TextInput
            autoComplete="off"
            className={classes.noLabelFix}
            data-cy="legal-middle-name"
            placeholder="Middle name…"
            name="middle_name"
            onBlur={(e) => {
              form.handleBlur(e);
              form.setFieldValue('middle_name', e.target.value.trim());
            }}
            value={form.values.middle_name}
            onChange={(e) => {
              if (!form.touched.stage_middle_name) form.setFieldValue('stage_middle_name', e.target.value.trim());
              form.handleChange(e);
            }}
          />
          <TextInput
            autoComplete="off"
            className={classes.noLabelFix}
            data-cy="legal-last-name"
            placeholder="Last name…"
            name="last_name"
            value={form.values.last_name}
            onBlur={(e) => {
              form.handleBlur(e);
              form.setFieldValue('last_name', e.target.value.trim());
            }}
            onChange={(e) => {
              if (!form.touched.stage_last_name) form.setFieldValue('stage_last_name', e.target.value.trim());
              if (form.errors.last_name && !form.touched.last_name) {
                form.setFieldTouched('last_name');
                form.validateField('last_name');
              }

              form.handleChange(e);
            }}
            errorMessage={getErrorMessage(form.touched.last_name, form.errors.last_name)}
          />
        </Grid>
        <Grid item style={{ marginBottom: 5 }}>
          <InputLabel style={{ justifyContent: 'unset' }}>
            Stage Name
            <BsAsterisk className="required-asterisk" />
          </InputLabel>
          <TextInput
            data-cy="stage-first-name"
            placeholder="Enter stage first name…"
            name="stage_first_name"
            onBlur={(e) => {
              form.handleBlur(e);
              form.setFieldValue('stage_first_name', e.target.value.trim());
            }}
            value={form.values.stage_first_name}
            onChange={(e) => {
              if (form.errors.stage_first_name && !form.touched.stage_first_name) {
                form.setFieldTouched('stage_first_name');
                form.validateField('stage_first_name');
              }
              form.handleChange(e);
            }}
            errorMessage={getErrorMessage(form.touched.stage_first_name, form.errors.stage_first_name)}
          />

          <TextInput
            className={classes.noLabelFix}
            data-cy="stage-middle-name"
            placeholder="Enter stage middle name…"
            name="stage_middle_name"
            onBlur={(e) => {
              form.handleBlur(e);
              form.setFieldValue('stage_middle_name', e.target.value.trim());
            }}
            value={form.values.stage_middle_name}
            onChange={(e) => {
              if (form.errors.stage_middle_name && !form.touched.stage_middle_name) {
                form.setFieldTouched('stage_middle_name');
                form.validateField('stage_middle_name');
              }
              form.handleChange(e);
            }}
            errorMessage={getErrorMessage(form.touched.stage_middle_name, form.errors.stage_middle_name)}
          />

          <TextInput
            className={classes.noLabelFix}
            data-cy="stage-last-name"
            placeholder="Enter stage last name…"
            name="stage_last_name"
            onBlur={(e) => {
              form.handleBlur(e);
              form.setFieldValue('stage_last_name', e.target.value.trim());
            }}
            value={form.values.stage_last_name}
            onChange={(e) => {
              if (form.errors.stage_last_name && !form.touched.stage_last_name) {
                form.setFieldTouched('stage_last_name');
                form.validateField('stage_last_name');
              }
              form.handleChange(e);
            }}
            errorMessage={getErrorMessage(form.touched.stage_last_name, form.errors.stage_last_name)}
          />
        </Grid>

        <div>
          <InputLabel style={{ justifyContent: 'unset' }}>
            Gender
            <BsAsterisk className="required-asterisk" />
          </InputLabel>
          <Select
            data-cy="gender-dropdown"
            variant="outlined"
            fullWidth
            data={type === 'minor' ? Gender.slice(0, 2) : Gender}
            value={form.values.gender}
            name="gender"
            className={classes.select}
            onBlur={() => form.setFieldTouched('gender')}
            onChange={(e) => {
              if (form.errors.gender && !form.touched.gender) {
                form.setFieldTouched('gender');
                form.validateField('gender');
              }
              form.handleChange(e);
            }}
            placeHolder="Select Gender"
            errorMessage={getErrorMessage(form.touched.gender && !form.values.gender, 'Gender is required')}
          />
        </div>

        <Grid item>
          <InputLabel style={{ justifyContent: 'unset', marginTop: 10 }}>
            Primary Ethnic Appearance
            <BsAsterisk className="required-asterisk" />
          </InputLabel>
          {/* <Select
                variant="outlined"
                fullWidth
                data={EthnicAppearances}
                IconComponent={SelectArrowDownIcon}
                placeHolder={'Select'}
                onChange={handleChange}
                name="ethnic_appearance_primary"
                value={generalInfo.ethnic_appearance_primary}
              /> */}
          <Autocomplete
            data-cy="ethnic-dropdown"
            onChange={(e, newValue) => {
              handleAutocompleteChange('ethnic_appearance_primary', newValue);
            }}
            value={generalInfo.ethnic_appearance_primary}
            options={EthnicAppearances.map((i) => i.value)}
            getOptionSelected={(option, value) => option === value}
            fullWidth
            renderInput={(params) => <TextInput placeholder={'Select'} {...params} />}
            disableClearable
          />
        </Grid>

        {form.values.country_code?.toLowerCase() === 'us' ? (
          <Grid item>
            <InputLabel style={{ justifyContent: 'unset', marginTop: 10 }}>
              Union
              <BsAsterisk className="required-asterisk" />
            </InputLabel>
            {form.values.unions?.length ? (
              form.values.unions.map((union: IUnion, index: number) => (
                <UnionChip
                  data-cy="asd"
                  key={index}
                  unionId={union.id_number}
                  removeUnion={() => removeUnion(union.id_number)}
                  setUnionId={(id: string) => {
                    form.setFieldValue('unions', [
                      {
                        id_number: id,
                        name: union.name,
                      },
                    ]);
                  }}
                  unionName={union.name}
                />
              ))
            ) : (
              <Select
                data-cy="union-dropdown"
                variant="outlined"
                fullWidth
                data={unionList}
                className={classes.select}
                // IconComponent={SelectArrowDownIcon}
                placeHolder={'Select'}
                onChange={(e) => {
                  form.setFieldValue('unions', [
                    {
                      id_number: '',
                      name: e.target.value,
                    },
                  ]);
                }}
                name="unions"
                value={form.values.unions}
              />
            )}
          </Grid>
        ) : (
          <React.Fragment />
        )}

        {profileMatch?.data.length || agency.name ? (
          <InputLabel id="representationStatus">Representation</InputLabel>
        ) : (
          <>
            <Grid item>
              <InputLabel id="representationStatus">Representation Status</InputLabel>
              <Select
                data-cy="representation-dropdown"
                variant="outlined"
                fullWidth
                className={classes.select}
                data={[
                  { key: RepresentationType.AGENCY_REPRESENTATION, value: RepresentationType.AGENCY_REPRESENTATION },
                  { key: RepresentationType.FREELANCE, value: RepresentationType.FREELANCE },
                ]}
                value={form.values.representation_type}
                onChange={(e: any) => {
                  form.setFieldValue('representation_type', e.target.value.trim());
                  if (e.target.value.trim() === 'Non-Represented') setRepresentatives([]);
                }}
                // IconComponent={SelectArrowDownIcon}
                name="representation_type"
              />
            </Grid>
            {form.values.representation_type === 'Non-Represented' ? (
              ''
            ) : (
              <Grid item>
                <div style={{ marginBottom: 10 }}>
                  <InputLabel id="representationStatus">Region</InputLabel>
                  <Select
                    data-cy="region-dropdown"
                    variant="outlined"
                    fullWidth
                    data={countries}
                    className={classes.select}
                    value={agencyRegion}
                    onChange={(e: any) => {
                      setagencyRegion(e.target.value);
                    }}
                    // IconComponent={SelectArrowDownIcon}
                    name="country"
                  />
                </div>
                <InputLabel style={{ justifyContent: 'unset', marginTop: 15 }}>
                  Add Representatives
                  <BsAsterisk className="required-asterisk" />
                </InputLabel>
                <Autocomplete
                  data-cy="add-representative-dropdown"
                  id="multiple-tags"
                  multiple
                  options={getData?.map((a) => ({ attributes: { ...a }, id: a.id })) || []}
                  getOptionLabel={(option: any) => {
                    const { full_name, name } = option.attributes;
                    //create a logic that will check current inputValue if it contains agency name then retunr the agency name else return the full name
                    if (queryValue.length > 0) {
                      if (full_name && full_name.toLowerCase().includes(queryValue.toLowerCase())) {
                        return full_name.toLowerCase();
                      } else {
                        return name;
                      }
                    }

                    return '';
                  }}
                  getOptionSelected={(option, value) => option === value}
                  fullWidth
                  renderTags={() => null}
                  onChange={(e, newValue: any[]) => {
                    if (newValue) {
                      setRepresentatives(newValue.filter((v, i, a) => a.findIndex((v2) => v2.id === v.id) === i));
                    }
                  }}
                  renderOption={(option: any) => {
                    const { name, company_type, country, company_logo, full_name, type } = option.attributes;

                    return (
                      <Grid
                        container
                        spacing={2}
                        style={{ margin: 5, display: 'flex', alignItems: 'center', gap: '.5em', flexWrap: 'nowrap' }}
                      >
                        <Grid item xs={1} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <img
                            style={{ borderRadius: 10 }}
                            loading="lazy"
                            width="37"
                            src={
                              company_logo ||
                              `https://ui-avatars.com/api/?background=random&name=${full_name || name}&length=1`
                            }
                            alt=""
                          />
                        </Grid>
                        <Grid item xs={11}>
                          <Grid item xs={12} style={{ fontSize: 16, fontWeight: 500 }}>
                            {full_name || name}
                          </Grid>
                          <Grid item xs={12} style={{ color: '#93a1b6', fontSize: 14 }}>
                            <div style={{ display: 'flex' }}>
                              <Typography
                                fontSize={12}
                                fontWeight={700}
                                style={{ fontStyle: 'italic' }}
                                color="lightGrey"
                              >
                                {name ? `${name} -\xa0` : ''}
                              </Typography>
                              <Typography fontSize={12} style={{ fontStyle: 'italic' }} color="lightGrey">
                                {type ? type : ' '}
                              </Typography>
                            </div>
                          </Grid>
                        </Grid>
                      </Grid>
                    );
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder={'Type / Search Agency…'}
                      variant="outlined"
                      margin="normal"
                      onChange={(e) => {
                        setQuery(e.target.value);
                        form.handleChange(e);
                      }}
                    />
                  )}
                />
                {/* <TextInput label={'Add Representatives'} placeholder="Type / Search Agency…" /> */}
              </Grid>
            )}
          </>
        )}

        <Grid item>
          {!isLoadingCompany ? (
            representatives.map((i) => (
              <RepresentationChip
                key={i.id}
                bypassCode={i.attributes.isCompany}
                agency={i}
                handleRemoveRepresentative={handleRemoveRepresentative}
                setRepresentatives={setRepresentatives}
                representatives={representatives}
              />
            ))
          ) : (
            <CircularProgress size={30} />
          )}

          {/* {agency.slug && companyData?.data ? (
            !isLoadingCompany ? (
              <RepresentationChip
                bypassCode
                agency={companyData?.data as any}
                handleRemoveRepresentative={handleRemoveRepresentative}
                setRepresentatives={setRepresentatives}
                representatives={representatives}
              />
            ) : (
              <CircularProgress size={30} />
            )
          ) : (
            <React.Fragment />
          )}

          {profileMatch?.data.length && companyData2?.data ? (
            !isLoadingCompany2 ? (
              <RepresentationChip
                bypassCode
                agency={companyData2?.data as any}
                handleRemoveRepresentative={handleRemoveRepresentative}
                setRepresentatives={setRepresentatives}
                representatives={representatives}
              />
            ) : (
              <CircularProgress size={30} />
            )
          ) : (
            <React.Fragment />
          )} */}
          {renderWorkingLocation()}
        </Grid>

        {/* <Grid item>
          <InputLabel id="representationStatus">Gender / Identity</InputLabel>
          <Select
            placeHolder={'Gender'}
            errorMessage={getErrorMessage(form.touched.gender, form.errors.gender)}
            name="gender"
            onChange={form.handleChange}
            onBlur={() => form.setFieldTouched('gender')}
            variant="outlined"
            fullWidth
            data={Gender}
            value={form.values.gender}
            IconComponent={SelectArrowDownIcon}
          />
          <Select
            placeHolder={'Identity'}
            className={classes.selectNoLabelFix}
            variant="outlined"
            fullWidth
            data={Pronouns}
            value={form.values.identifies_as}
            IconComponent={SelectArrowDownIcon}
            name="identifies_as"
            onChange={form.handleChange}
          />
        </Grid> */}
        {/* <Grid item>
          <InputLabel id="representationStatus">Your SAG Status</InputLabel>
          <Select
            variant="outlined"
            fullWidth
            data={[
              { key: 'NON MEMBER', value: 'NON MEMBER' },
              { key: 'SAG/AFTRA', value: 'SAG/AFTRA' },
              { key: 'SAG ELIGIBLE', value: 'SAG ELIGIBLE' },
              { key: 'SAG CORE', value: 'SAG CORE' },
            ]}
            value={form.values.sag_status}
            IconComponent={SelectArrowDownIcon}
            name="sag_status"
            onChange={form.handleChange}
          />
          {form.values.sag_status !== 'NON MEMBER' && (
            <TextInput
              onChange={form.handleChange}
              value={form.values.sag_id}
              className={classes.noLabelFix}
              placeholder="Enter SAG ID..."
              name="sag_id"
            />
          )}
        </Grid>
        <Grid item>
          <InputLabel id="representationStatus" style={{ marginBottom: 15 }}>
            Select Other Unions You Belong To
          </InputLabel>
          {form.values.unions &&
            Array.isArray(form.values.unions) &&
            form.values.unions.map((union, index) => (
              <TwoColumn>
                <div>
                  <Select
                    variant="outlined"
                    data={unionList}
                    IconComponent={SelectArrowDownIcon}
                    fullWidth
                    placeHolder="Select a Union"
                    value={union.name}
                    onChange={(e) => {
                      const { value } = e.target as { value: string };
                      form.setFieldValue(`unions[${index}].name`, value);
                    }}
                    errorMessage={getErrorMessage(
                      getIn(form.touched, `unions[${index}].name`),
                      getIn(form.errors, `unions[${index}].name`),
                    )}
                  />
                </div>
                <div>
                  <TextInput
                    placeholder="Enter ID"
                    name={`unions[${index}].id_number`}
                    value={union.id_number}
                    onChange={(e) => {
                      const { value } = e.target as { value: string };
                      form.setFieldValue(`unions[${index}].id_number`, value);
                    }}
                    errorMessage={getErrorMessage(
                      getIn(form.touched, `unions[${index}].id_number`),
                      getIn(form.errors, `unions[${index}].id_number`),
                    )}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <RemoveIconTwoTone
                            onClick={() => removeUnion(index)}
                            style={{ fontSize: '16px', cursor: 'pointer' }}
                          />
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
              </TwoColumn>
            ))}
          <AddNewUnionButton fullWidth startIcon={<PlusIconTwoTone />} onClick={() => addUnion()}>
            Add New Union
          </AddNewUnionButton>
        </Grid> */}
        {openLocationModal ? (
          <LocationModal
            open={openLocationModal}
            onClose={setopenLocationModal}
            data={selectedLocation}
            ifNoAddresses={Boolean(selectedLocation)}
            type="work"
            setSelectedLocation={setSelectedLocation}
            country={country}
          />
        ) : (
          <React.Fragment />
        )}
        {openAgeRangeModal ? (
          <CustomDialog
            open={openAgeRangeModal}
            onClose={() => setopenAgeRangeModal(false)}
            maxWidth="sm"
            fullWidth
            aria-labelledby="simple-dialog-title"
          >
            <div style={{ padding: '40px 40px 20px 40px' }}>
              {type === 'minor' ? (
                <MinorSlider
                  slim
                  val={val}
                  setVal={setVal}
                  birth={{
                    year: (form.values.birth_date as any).split('-')[0],
                    month: (form.values.birth_date as any).split('-')[1],
                    day: (form.values.birth_date as any).split('-')[2],
                  }}
                />
              ) : (
                <AdultSlider slim val={val} setVal={setVal} />
              )}
              <Button
                fullWidth
                variant="contained"
                color="primary"
                onClick={() => setopenAgeRangeModal(false)}
                style={{ background: PRIMARY_BUTTON_BACKGROUND, marginTop: 40 }}
              >
                Done
              </Button>
            </div>
          </CustomDialog>
        ) : (
          <React.Fragment />
        )}
      </Grid>
    </Box>
  );
};

export default AddNewMember;
